import { injectable, inject } from 'inversify-props';
import { MealCountKey, ProgramType, MealCountDto, DashboardCountStatus, MealType } from '@/models';
import { ISyncService, IMealCountService } from '@/services';
import { GetCountStatusesCommand } from './commands';

export interface IMealCountStatusService {
  getDefaultStatuses(): any;
  buildCountStatuses(keys: MealCountKey[]): any;
  buildDailyKeys(mealTypes, selectedSiteId, mealDate): MealCountKey[];
}

@injectable()
export class MealCountStatusService implements IMealCountStatusService {
  @inject() private syncService!: ISyncService;
  @inject() private mealCountService!: IMealCountService;

  getDefaultStatuses() {
    // always return a new instance of defaults
    return {
      non_congregate: new DashboardCountStatus(MealType[MealType.NonCongregate]),
      breakfast: new DashboardCountStatus(MealType[MealType.Breakfast]),
      snack_am: new DashboardCountStatus(MealType[MealType.SnackAM]),
      lunch: new DashboardCountStatus(MealType[MealType.Lunch]),
      snack_pm: new DashboardCountStatus(MealType[MealType.SnackPM]),
      supper: new DashboardCountStatus(MealType[MealType.Supper])
    };
  }

  async buildCountStatuses(keys: MealCountKey[]) {
    await this.syncService.syncMealsDown(keys);
    const counts = this.mealCountService.findMealCounts(keys);
    return this.getCountStatuses(counts);
  }

  buildDailyKeys(mealTypes, selectedSiteId, mealDate): MealCountKey[] {
    // Service downloads the count and sets in store.
    let keys: MealCountKey[] = [];
    for (let mealType of mealTypes) {
      keys.push(new MealCountKey(selectedSiteId!, ProgramType.SFSP, mealType, mealDate!));
    }
    return keys;
  }

  private getCountStatusesCmd = new GetCountStatusesCommand();
  getCountStatuses(counts: MealCountDto[]) {
    let statuses = this.getDefaultStatuses();
    if (counts.length > 0) {
      const countStatuses = this.getCountStatusesCmd.run(counts);

      for (let status of countStatuses) {
        statuses[status.mealTypeId.toLowerCase()] = status;
      }
    }
    return statuses;
  }
}
